function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".payez-apres_svg__st2{fill:#fff}.payez-apres_svg__st5{fill:none;stroke-miterlimit:10;stroke:#0e3935;stroke-width:7.0164;stroke-linecap:round}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M125.8 113.7c.8 5.4-2.9 10.4-8.3 11.2l-94.8 14.4c-5.4.8-10.4-2.9-11.2-8.3l-9-59.3c-.8-5.4 2.9-10.4 8.3-11.2l94.8-14.4c5.4-.8 10.4 2.9 11.2 8.3l9 59.3z",
  fill: "#f7bdbd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-8.66 61.67 76.488)",
  d: "M3.9 68.7h115.6v15.6H3.9z",
  fill: "#0e3935"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "payez-apres_svg__st2",
  d: "M39.5 118.3c.3 1.7-.9 3.2-2.6 3.5l-11.4 1.7c-1.7.3-3.2-.9-3.5-2.6l-1.7-11.4c-.3-1.7.9-3.2 2.6-3.5l11.4-1.7c1.7-.3 3.2.9 3.5 2.6l1.7 11.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2 104.4l18.5-2.8M51.1 117l30.1-4.6M74 100.6l32-4.8",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 5.262,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M122.5 84.4c-18.8 0-34.1-15.3-34.1-34.1s15.3-34.1 34.1-34.1 34.1 15.3 34.1 34.1-15.4 34.1-34.1 34.1z",
  fill: "#ffd800"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "payez-apres_svg__st2",
  d: "M122.5 19.8c16.9 0 30.5 13.7 30.5 30.5s-13.7 30.5-30.5 30.5-30.6-13.6-30.6-30.5 13.7-30.5 30.6-30.5m0-7c-20.7 0-37.6 16.9-37.6 37.6S101.8 88 122.5 88 160 71 160 50.3s-16.8-37.5-37.5-37.5z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "payez-apres_svg__st5",
  d: "M110.4 48.2l10.8 9.1 18.1-15.9M33.7 45.5c11.9-14.7 30-24.1 50.4-24.1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "payez-apres_svg__st5",
  d: "M79.6 13.2l8.2 8.2-8.2 8.2"
});

function SvgPayezApres(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    id: "payez-apres_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 154 154",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

export default SvgPayezApres;